import React from 'react';
import {
  BrowserRouter, Route, Switch, withRouter,
} from 'react-router-dom';
import IntegrationsAuditPage from './pages/IntegrationsAudit';
import SharedError from './pages/SharedError';
import SigninOidcPage from './pages/SigninOidc';
import SignoutOidcPage from './pages/SignoutOidc';
import SilentRefresh from './pages/SilentRefresh';

const Routes = () => (
  <BrowserRouter>
    <Switch>
      <Route exact path="/" component={withRouter(IntegrationsAuditPage)} />
      <Route exact path="/shared/error" component={withRouter(SharedError)} />
      <Route exact path="/signin-oidc" component={SigninOidcPage} />
      <Route exact path="/signout-oidc" component={SignoutOidcPage} />
      <Route exact path="/silent-refresh" component={SilentRefresh} />
      <Route component={SharedError} />
    </Switch>
  </BrowserRouter>
);

export default Routes;
